import * as actionTypes from '../actions/actionTypes';
import { firestore } from '../../config/firebase';

export const createUser = (data) => {
    return {
        type: actionTypes.CREATE_USER,
        data: data
    }
}

export const fetchUser = (data) => {
    return {
        data,
        type: actionTypes.FETCH_USER
    }
}
export const reFetchUser = (id) => {
    return firestore
        .collection('users')
        .doc(id)
        .get()
        .then(doc => {
            return {
                data: {...doc.data() },
                type: actionTypes.FETCH_USER
            }
        })


}

export const clearUserData = () => {
    return {
        type: actionTypes.CLEAR_USER_DATA
    }
}